import React, { Component, Suspense } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Testimonial from './Testimonial';
import Priority from './Priority';
import { Outlet } from 'react-router-dom';

const AppLayout = ({children}) => {
    return (
        <div>
            <div className="page-wrapper">
                <div className="page-body-wrapper">
                    <Navbar />
                    <div className="page-body">
                        <Outlet />
                    </div>
                    {/* <Testimonial /> */}
                    {/* <Priority /> */}
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default AppLayout;